import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import CachedResponse from '../common/CachedResponse';
import NotFound from '../NotFound';
import CRMPipeline from './CRMPipeline';
import InventoryPipeline from './InventoryPipeline';
import Pipeline from './Pipeline';
import { useLocation } from 'react-router-dom';
import useRefetchChoices from '../../hooks/useRefetchChoices';
import {
  ROLE_ADMIN,
  ROLE_INSTALLER,
  ROLE_INVENTORY_MANAGER,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SERVICE,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';

const PipelineRoutes = () => {
  const location = useLocation();
  const { triggerRefetch, refetchChoices, handleRefetchComplete } = useRefetchChoices();

  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/pipeline">
          <CachedResponse
            listEndpoint="app-choices"
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <Pipeline appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route exact path="/pipeline/crm">
          <CachedResponse
            listEndpoint="app-choices"
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <CRMPipeline appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route exact path="/pipeline/inventory">
          <CachedResponse
            listEndpoint="app-choices"
            triggerRefetch={triggerRefetch}
            onRefetchComplete={handleRefetchComplete}
            render={appChoices => <InventoryPipeline appChoices={appChoices} refetchChoices={refetchChoices} />}
          />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  if (
    !(
      userHasAnyRole(
        ROLE_SUPER_ADMIN,
        ROLE_ADMIN,
        ROLE_SERVICE,
        ROLE_SALES,
        ROLE_SALES_MANAGER,
        ROLE_INSTALLER,
        ROLE_SALES_AND_INVENTORY_MANAGER
      ) ||
      (userHasAnyRole(ROLE_INVENTORY_MANAGER) && location.pathname.includes('/pipeline/inventory'))
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return getActivePage();
};

export default withRouter(PipelineRoutes);
